import * as React from "react";
const SvgFiRrArchway = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-archway_svg__a)">
      <path
        fill="#062147"
        d="M23 21h-1V6.414l1.3-1.298a2.4 2.4 0 0 0 .521-2.627 2.405 2.405 0 0 0-2.228-1.488H2.406A2.4 2.4 0 0 0 .18 2.488a2.41 2.41 0 0 0 .522 2.628L2 6.414V21H1a1 1 0 1 0 0 2h4c1.654 0 3-1.346 3-3v-5c0-2.206 1.794-4 4-4s4 1.794 4 4v5c0 1.654 1.346 3 3 3h4a1 1 0 1 0 0-2M2.026 3.254A.39.39 0 0 1 2.406 3h19.188c.24 0 .341.159.38.254a.39.39 0 0 1-.089.448L20.586 5H3.414L2.115 3.702a.39.39 0 0 1-.089-.448M18 20v-5c0-3.309-2.69-6-6-6s-6 2.691-6 6v5c0 .551-.448 1-1 1H4V7h16v14h-1c-.552 0-1-.449-1-1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-archway_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrArchway;
